var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20h10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12v-4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12v-1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12v-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12v-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytical);
export default __webpack_public_path__ + "static/media/analytical.82524ef1f1dd1ae4862ccac078db763f.svg";
export { ForwardRef as ReactComponent };